import React from 'react';
import { Box as MuiBox } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Box Atom
 * A versatile layout primitive for building responsive layouts
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content
 * @param {string} props.component - HTML element to render
 * @param {Object} props.sx - MUI styling object
 * @returns {React.ReactElement} Box component
 */
const Box = ({ children, component, sx = {}, ...rest }) => {
  return (
    <MuiBox
      component={component}
      sx={sx}
      {...rest}
    >
      {children}
    </MuiBox>
  );
};

Box.propTypes = {
  children: PropTypes.node,
  component: PropTypes.string,
  sx: PropTypes.object
};

export default Box;